import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../pages/Login.css";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import { FlagTH, FlagUS } from "../components/FlagIcon";
import API from "../config";

function ResetPassword() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { lang, toggle } = useLanguage();

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const conditions = {
    minLength: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const isValid = Object.values(conditions).every(Boolean);

  const resetPassword = async () => {
    if (!isValid) { setError("Password does not meet security requirements."); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: state.email, password })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Something went wrong"); return; }
      alert("Password updated successfully");
      navigate("/");
    } catch (err) {
      setError("Cannot connect to server");
    } finally {
      setLoading(false);
    }
  };

  const getColor = (condition) => ({ color: condition ? "#0b6e00" : "#ff4d4f", transition: "0.3s" });

  return (
    <div className="login-bg">
      <button
        onClick={toggle}
        style={{ position: "fixed", top: 16, right: 16, background: "none", border: "none", cursor: "pointer", zIndex: 100 }}
        title={lang === "th" ? "Switch to English" : "เปลี่ยนเป็นภาษาไทย"}
      >
        {lang === "th" ? <FlagUS size={28} /> : <FlagTH size={28} />}
      </button>

      <div className="glass-card">
        <h4 className="text-center mb-4">{t(lang, "resetPwdTitle")}</h4>

        <div className="input-group-glass">
          <label>{t(lang, "newPassword")}</label>
          <input
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(""); }}
          />
        </div>

        <div style={{ fontSize: "13px", marginBottom: "15px" }}>
          {[
            { key: "minLength", labelKey: "pwdMin" },
            { key: "upper",     labelKey: "pwdUpper" },
            { key: "lower",     labelKey: "pwdLower" },
            { key: "number",    labelKey: "pwdNumber" },
            { key: "special",   labelKey: "pwdSpecial" },
          ].map(({ key, labelKey }) => (
            <div key={key} style={getColor(conditions[key])}>• {t(lang, labelKey)}</div>
          ))}
        </div>

        {error && <p className="text-danger text-center mb-2">{error}</p>}

        <button className="glass-btn-login" onClick={resetPassword} disabled={loading || !isValid}>
          {loading ? t(lang, "saving") : t(lang, "savePassword")}
        </button>
      </div>
    </div>
  );
}

export default ResetPassword;
